import { Box } from "@mui/material";
import { HeaderStep } from "../../templates/Header/Header";
import Basket from "../../molecules/Basket/Basket";

interface Props {
  headerStep: HeaderStep;
  children?: JSX.Element;
  onValidatePromoCode?: (code: string | null) => Promise<boolean>;
}

const Footer = ({ headerStep, children, onValidatePromoCode }: Props) => {
  const switchTextBackgroundColor = (): string => {
    return "white";
  };

  return (
    <Box className="Footer" sx={{ background: switchTextBackgroundColor() }}>
      <Box className="footerContent">
        {onValidatePromoCode && <Basket onValidatePromoCode={onValidatePromoCode} />}
        {children}
      </Box>
    </Box>
  );
};

export default Footer;
